interface IconProps {
  color?: string
}

export const Change = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1043 4.00001C27.5856 3.99828 27.9772 4.3775 27.979 4.84702L28 10.4277C28.0064 12.1344 26.5923 13.5189 24.8426 13.5189H19.1215C18.6402 13.5189 18.25 13.1383 18.25 12.6688C18.25 12.1993 18.6402 11.8187 19.1215 11.8187H24.8426C24.844 11.8187 24.8454 11.8187 24.8467 11.8187C23.2585 8.58516 19.8724 6.35422 15.9541 6.35422C11.8197 6.35422 8.27785 8.83802 6.81526 12.3626C6.63466 12.7978 6.12657 13.0078 5.68041 12.8316C5.23426 12.6554 5.01898 12.1598 5.19958 11.7246C6.91944 7.58008 11.0854 4.65395 15.9541 4.65395C20.4171 4.65395 24.2897 7.1128 26.2288 10.715C26.2476 10.6243 26.2573 10.5303 26.257 10.4339L26.236 4.85326C26.2342 4.38374 26.623 4.00173 27.1043 4.00001ZM5.75752 21.3622C5.74773 21.4287 5.74278 21.4968 5.74304 21.5661L5.76404 27.1467C5.7658 27.6163 5.37705 27.9983 4.89573 28C4.4144 28.0017 4.02278 27.6225 4.02102 27.153L4.00002 21.5723C3.9936 19.8656 5.40773 18.4811 7.15741 18.4811H12.8785C13.3598 18.4811 13.75 18.8617 13.75 19.3312C13.75 19.8007 13.3598 20.1813 12.8785 20.1813H7.15741C7.13634 20.1813 7.11537 20.1818 7.09453 20.1827C8.69641 23.3801 12.0628 25.5804 15.9541 25.5804C20.0885 25.5804 23.6303 23.0966 25.0929 19.572C25.2735 19.1368 25.7816 18.9268 26.2278 19.103C26.6739 19.2792 26.8892 19.7748 26.7086 20.21C24.9887 24.3545 20.8228 27.2807 15.9541 27.2807C11.5502 27.2807 7.72128 24.8866 5.75752 21.3622Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
